

'use strict';
angular.module('pulianiBookStoreApp')
  .controller('TermsCtrl', function ($scope,$rootScope) {
$rootScope.title='Terms and Conditions';


});

